import { defineMessages } from 'react-intl';

export default defineMessages({
    MainDriverLabel: {
        id: 'cep.components.sgEndorsementDriverAdditionalQuestions.MainDriverLabel',
        defaultMessage: 'Which driver will be main driver? '
    },
    MainDriverValidation: {
        id: 'cep.components.sgEndorsementDriverAdditionalQuestions.MainDriverValidation',
        defaultMessage: 'Please select a main driver'
    }
});
